module.exports = __webpack_public_path__ + "static/media/up_emergency_bg_mobile.b45863ea.png";